module.exports = {"audiences":["newUsers","allMembers"],"autoTrack":true,"experimentAllocation":{"newUsers":1,"allMembers":0.1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-03-17"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/distinctLists.json
// module id = 0Vla
// module chunks = 2